"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.video25 = void 0;
var util_1 = require("./util");
var video25 = function (event) {
    return (0, util_1.videoEvent)(event, "video-25");
};
exports.video25 = video25;
